import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, RotateCcw } from "lucide-react";
import api, { errMsg } from "@/lib/api";
import { fmtDateTime, fmtMoney } from "@/lib/constants";
import { PageHeader, StatusBadge } from "@/components/shared";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function DeletedProjects() {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/projects/deleted").then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);
  const restore = async (p) => { try { await api.post(`/projects/${p.id}/restore`); toast.success(`${p.project_code} restored`); load(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div data-testid="deleted-projects-page">
      <PageHeader title="Deleted Projects" subtitle="Recoverable deletions. Restoring keeps the same project ID, files, checklist, source references, invoices and history.">
        <Button variant="outline" asChild><Link to="/projects" data-testid="back-to-projects"><ArrowLeft className="h-4 w-4 mr-1" /> Projects</Link></Button>
      </PageHeader>
      <div className="rounded-lg border border-slate-200 bg-white overflow-hidden">
        <Table>
          <TableHeader><TableRow className="bg-slate-50"><TableHead>ID</TableHead><TableHead>Project</TableHead><TableHead>Client</TableHead><TableHead>Stage</TableHead><TableHead className="text-right">Fee</TableHead><TableHead>Deleted</TableHead><TableHead></TableHead></TableRow></TableHeader>
          <TableBody>
            {rows.map((p) => (
              <TableRow key={p.id} data-testid={`deleted-row-${p.project_code}`}>
                <TableCell className="font-mono text-xs text-slate-600">{p.project_code}</TableCell>
                <TableCell className="font-medium text-slate-800">{p.name}</TableCell>
                <TableCell className="text-sm text-slate-600">{p.client_name || <i className="text-slate-400">no client</i>}</TableCell>
                <TableCell><StatusBadge status={p.status} /></TableCell>
                <TableCell className="text-right tabular-nums text-sm">{p.fee_amount != null ? fmtMoney(p.fee_amount, p.fee_currency) : "—"}</TableCell>
                <TableCell className="text-xs text-slate-500">{fmtDateTime(p.deleted_at)} · {p.deleted_by}</TableCell>
                <TableCell className="text-right"><Button size="sm" variant="outline" onClick={() => restore(p)} data-testid={`restore-${p.project_code}`}><RotateCcw className="h-3 w-3 mr-1" /> Restore</Button></TableCell>
              </TableRow>
            ))}
            {rows.length === 0 && <TableRow><TableCell colSpan={7} className="text-center text-sm text-slate-400 py-10" data-testid="deleted-empty">No deleted projects.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
